export default __webpack_public_path__ + "static/media/seven_of_wands.2bea7e05.png";